var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRight = function SvgRight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5304 7.55042L4.48036 1.26292C4.45932 1.24636 4.43404 1.23607 4.40742 1.23323C4.3808 1.23038 4.35392 1.23511 4.32987 1.24686C4.30581 1.25861 4.28556 1.2769 4.27143 1.29964C4.2573 1.32238 4.24987 1.34865 4.25 1.37542V2.75578C4.25 2.84328 4.29107 2.9272 4.35893 2.98078L10.7875 8.00042L4.35893 13.0201C4.28929 13.0736 4.25 13.1576 4.25 13.2451V14.6254C4.25 14.7451 4.3875 14.8111 4.48036 14.7379L12.5304 8.45042C12.5988 8.39705 12.6541 8.32878 12.6922 8.2508C12.7303 8.17282 12.7501 8.08719 12.7501 8.00042C12.7501 7.91364 12.7303 7.82801 12.6922 7.75004C12.6541 7.67206 12.5988 7.60379 12.5304 7.55042Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/right.edcabbae.svg";
export { ForwardRef as ReactComponent };